/** Parse lastSentDate / bubble sentDate. Return a label only when the value parses. Omit otherwise (Q3). */

const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function parseMessageDate(value: string | null | undefined): Date | null {
    if (value == null) return null;
    const raw = String(value).trim();
    if (!raw) return null;
    // API createdAt is stampDateTime → Date.toISOString() (UTC, e.g. 2026-08-26T18:03:00.000Z).
    // The naive calendar regex also matches that prefix and would treat 18:03 as local (IST),
    // so a just-sent message shows ~5h ago. Honor TZ (Z / offset / ISO T) via Date.parse first.
    if (/T/.test(raw) || /[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
        const instant = Date.parse(raw);
        if (!Number.isNaN(instant)) {
            const date = new Date(instant);
            return Number.isNaN(date.getTime()) ? null : date;
        }
    }
    const cal = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(raw);
    if (cal) {
        const date = new Date(
            Number(cal[1]),
            Number(cal[2]) - 1,
            Number(cal[3]),
            cal[4] == null ? 0 : Number(cal[4]),
            cal[5] == null ? 0 : Number(cal[5]),
            cal[6] == null ? 0 : Number(cal[6])
        );
        return Number.isNaN(date.getTime()) ? null : date;
    }
    const ms = Date.parse(raw);
    if (Number.isNaN(ms)) return null;
    const date = new Date(ms);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatMessageTime(value: string | null | undefined, now = new Date()): string | null {
    const date = parseMessageDate(value);
    if (!date) return null;
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) {
        return formatAbsolute(date);
    }
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days}d ago`;
    return formatAbsolute(date);
}

function formatAbsolute(date: Date): string {
    return `${date.getDate()} ${SHORT_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
